import { useCallback, useEffect, useSyncExternalStore } from 'react';
import { currentProductImage, scheduleProductImageRefresh, subscribeProductImage } from './product-image-sync';

export function ProductImage({ productId, imageUrl, alt = '' }: {
  productId: string;
  imageUrl?: string | null | undefined;
  alt?: string;
}) {
  const subscribe = useCallback((listener: () => void) => subscribeProductImage(productId, listener), [productId]);
  const snapshot = useCallback(() => currentProductImage(productId), [productId]);
  const synchronized = useSyncExternalStore(subscribe, snapshot, () => undefined);
  // A refreshed list may carry a newer URL. Reconcile against the server now,
  // without letting an older list response undo a just-completed upload.
  useEffect(() => { scheduleProductImageRefresh(); }, [productId, imageUrl]);
  const url = synchronized === undefined ? imageUrl : synchronized;
  return url ? <img src={url} alt={alt} loading="lazy" decoding="async" /> : <span aria-label={alt ? `${alt}：暂无主图` : undefined}><i /><i /><i /></span>;
}
